// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"438":"Login","726":"Index"}[chunkId] + "." + {"438":"e2997189","726":"1a3ae489"}[chunkId] + ".js";
};